import { useState } from 'react';
import { Chip, Stack } from '@mui/material';
import { LocationInfoEditDialog } from './location-info-edit-dialog';
import { useRecommendationProfile } from '@/context/recommendation-profile';
import type { RecommendationProfile } from '@/models/recommendation';
import { ProfileItem } from '@/packages/my-profile/components/profile-item';

export const LocationInfo = () => {
  const { profile, updateProfile } = useRecommendationProfile();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleSave = (locationInfo: Partial<RecommendationProfile>) => {
    updateProfile({
      profile: {
        ...profile,
        address_city: locationInfo.address_city,
        address_state: locationInfo.address_state,
        non_resident: locationInfo.non_resident,
      },
    });
    setIsDialogOpen(false);
  };

  const isNonResident = profile?.non_resident;

  const locationInfoLabel = isNonResident
    ? 'Não moro no Brasil'
    : `${profile?.address_city} - ${profile?.address_state}`;

  const hasLocationInfo =
    (profile?.address_city && profile?.address_state) || profile?.non_resident;

  return (
    <>
      <ProfileItem title="Localização" onClick={() => setIsDialogOpen(true)}>
        {hasLocationInfo && (
          <Stack direction="row" gap={2} flexWrap="wrap">
            <Chip label={locationInfoLabel} />
          </Stack>
        )}
      </ProfileItem>
      {isDialogOpen && profile && (
        <LocationInfoEditDialog
          currentValues={profile}
          onClose={() => setIsDialogOpen(false)}
          onSave={handleSave}
        />
      )}
    </>
  );
};
